import './LayoutEditor.css';

import { FC, useMemo } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import RequestDataProvider from '../../context/RequestDataContext';
import LayoutEditorProvider from '../../context/LayoutEditorContext/LayoutEditorContext';
import LayoutHandlersProvider from '../../context/LayoutHandlersContext/LayoutHandlersContext';
import LayoutObjectTemplateProvider from '../../context/LayoutObjectTemplateContext';
import ResponseActionsProvider from '../../context/ResponseActionsContext';
import ResponseActionsScopeProvider from '../../context/ResponseActionsScopeContext';
import { useUserState } from '../../hooks/context/useUserState';
import { getLayoutApiRequestData } from '../../api/utils/requestData/getLayoutApiRequestData';
import LayoutEditorContent from '../../components/Manager/LayoutEditorContent/LayoutEditorContent';
import LayoutEditorReference from '../Reference/LayoutEditorReference';
import useRoutes from '../../hooks/useRoutes';

const LayoutEditor: FC = () => {
  const routes = useRoutes();
  const { datasetId, layoutId, objectId } = useParams<{
    datasetId: string;
    layoutId: string;
    objectId?: string;
  }>();
  const {
    state: { token },
  } = useUserState();
  // The editor route matches the reference URL too (prefix match), so the
  // providers stay mounted while the fullscreen reference page is shown.
  const referenceMatch = useRouteMatch(routes.relative.layoutEditorReference());

  // Request data context feeds JSONata resolution of the layout apiMethods.
  const requestData = useMemo(
    () => getLayoutApiRequestData(objectId ?? '', token, datasetId),
    [objectId, token, datasetId]
  );

  return (
    <RequestDataProvider requestData={requestData}>
      <ResponseActionsScopeProvider scope="layoutEditor">
        <LayoutObjectTemplateProvider>
          <LayoutEditorProvider layoutId={layoutId} objectId={objectId}>
            <LayoutHandlersProvider>
              {referenceMatch ? (
                <LayoutEditorReference />
              ) : (
                <LayoutEditorContent />
              )}
            </LayoutHandlersProvider>
          </LayoutEditorProvider>
        </LayoutObjectTemplateProvider>
      </ResponseActionsScopeProvider>
    </RequestDataProvider>
  );
};

export default LayoutEditor;
